import React, { createContext, useState } from 'react';

export interface ITabNavigation {
  path: string;
  title: string;
}

interface INavigationContext {
  title: React.ReactNode;
  setTitle: (title: React.ReactNode) => void;
  subtitle: React.ReactNode;
  setSubtitle: (subtitle: React.ReactNode) => void;
  tabNavigation: ITabNavigation[];
  setTabNavigation: (tabNavigation: ITabNavigation[]) => void;
  isNavigationBarVisible: boolean;
  setIsNavigationBarVisible: (showNavigationBar: boolean) => void;
  isTabNavigationSticky: boolean;
  setIsTabNavigationSticky: React.Dispatch<React.SetStateAction<boolean>>;
  showLogo: boolean;
  setShowLogo: (showLogo: boolean) => void;
  toolbarSection: React.ReactNode | null;
  setToolbarSection: React.Dispatch<React.SetStateAction<JSX.Element | null>>;
  headHeight: number;
  setHeadHeight: (headHeight: number) => void;
}

export const NavigationContext = createContext<INavigationContext | undefined>(undefined);

const NavigationProvider = ({ children }) => {
  const [title, setTitle] = useState('');
  const [subtitle, setSubtitle] = useState('');
  const [tabNavigation, setTabNavigation] = useState([]);
  const [isNavigationBarVisible, setIsNavigationBarVisible] = useState(true);
  const [isTabNavigationSticky, setIsTabNavigationSticky] = useState(false);
  const [showLogo, setShowLogo] = useState(false);
  const [toolbarSection, setToolbarSection] = useState();
  const [headHeight, setHeadHeight] = useState(0);

  return (
    <NavigationContext.Provider
      value={{
        title,
        setTitle,
        subtitle,
        setSubtitle,
        tabNavigation,
        setTabNavigation,
        isNavigationBarVisible,
        setIsNavigationBarVisible,
        isTabNavigationSticky,
        setIsTabNavigationSticky,
        showLogo,
        setShowLogo,
        toolbarSection,
        setToolbarSection,
        headHeight,
        setHeadHeight,
      }}
    >
      {children}
    </NavigationContext.Provider>
  );
};

export default NavigationProvider;
